import { Text } from '@equip.health/ui';
import { TextProps } from '@equip.health/ui/lib/types/src/components/Text/Text';
import { CarePlanInterventionResponse } from '~/lib/types/carePlan/carePlans';
import { RefCarePlanInterventionCategoryResponse } from '~/lib/types/carePlan/customInterventions';

type InterventionTextProps = Omit<TextProps, 'children'> & {
  intervention: CarePlanInterventionResponse;
  categories?: RefCarePlanInterventionCategoryResponse[];
};

export const InterventionText = ({
  intervention,
  categories,
  ...textProps
}: InterventionTextProps) => {
  const displayText =
    intervention.intervention?.label || intervention.description;

  if (intervention.isCustom) {
    const categoryLabel =
      categories?.find((cat) => cat.code === intervention.categoryCode)
        ?.label ?? 'Other';

    return (
      <Text {...textProps}>
        <span style={{ fontWeight: 500 }}>{categoryLabel}: </span>
        {displayText}
      </Text>
    );
  }

  return <Text {...textProps}>{displayText}</Text>;
};
